import { useCallback, useEffect, useState } from "react";

export function useCountdownTimer(initialSeconds: number) {
    const [countdown, setCountdown] = useState(initialSeconds);

    const startTimer = useCallback(() => {
        setCountdown(initialSeconds);
    }, [initialSeconds]);

    useEffect(() => {
        setCountdown(initialSeconds);
    }, [initialSeconds]);

    useEffect(() => {
        if (countdown === 0) return;
        const timer = setInterval(() => {
            setCountdown((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [countdown]);

    return {
        countdown,
        startTimer,
    };
}
